import { createTranslator, mergeCatalogs, resolveLanguage, type AnyLanguage } from '@lumlab/platform-i18n';
import platformFr from '@lumlab/platform-i18n/locales/fr.json' with { type: 'json' };
import { products } from '../products.ts';

/** `?lang=pseudo` shows the pseudo language in development, to spot hard-coded texts and overflows. */
function initialLanguage(): AnyLanguage {
    if (import.meta.env.DEV && new URLSearchParams(window.location.search).get('lang') === 'pseudo') {
        return 'pseudo';
    }
    return resolveLanguage({ browser: navigator.languages });
}

export async function createAppTranslator() {
    const fr = mergeCatalogs({
        platform: platformFr,
        ...Object.fromEntries(products.map((product) => [product.id, product.catalogs.fr ?? {}])),
    });
    const language = initialLanguage();
    const i18n = await createTranslator({ language, resources: { fr }, pseudo: import.meta.env.DEV });
    document.documentElement.lang = language === 'pseudo' ? 'fr' : language;
    return i18n;
}
